<template>
    <div>
        <component v-bind:is="activeSubItem"></component>
    </div>
</template>

<script>

import AboutGame from '@fg/base/components/partials/settings/subitems/info/AboutGame';
import Paytable from '@fg/base/components/partials/settings/subitems/info/Paytable';
import Tickets from '@fg/base/components/partials/settings/subitems/info/Tickets';

export default {
    components: {AboutGame, Paytable, Tickets},
    props: ['activeSubItem'],
    
    methods: {
    }
}
</script>